import React, { Component } from "react";
import { fetch_retry } from "./service/getinfo";
import { NotificationManager } from 'react-notifications';
import ScrollContainer from 'react-indiana-drag-scroll'
import { Redirect, BrowserRouter, Route, Switch } from "react-router-dom";
import Logout from "./../logout";

var config = require('../config.js');
const backend = config.backend;

class Manage_Staff extends Component {

  _isMounted = false;

  state = {
    staffs: [],
    redirectLogout: false
  }

  /**
   * Loads the full staff list from the API when the screen mounts.
   * @return {void}
   */
  componentDidMount() {
    this._isMounted = true;
    this.getStaffs();
  }

  /**
   * Prevents state updates after unmount when async staff fetch completes.
   * @return {void}
   */
  componentWillUnmount() {
    this._isMounted = false;
  }

  /**
   * Fetches all staff from the backend, handles session redirect, sorts by type/name, and updates `staffs` in state.
   * @return {void}
   */
  getStaffs = _ => {
    fetch_retry(backend + `api/staff/all`, {
      method: 'GET',
      credentials: "include"
    }, 3)
      .then(response => response.json())
      .then(response => {

        if (response.redirect) {
          this.setState({ redirectLogout: true })
          window.location.reload(false);
        }

        var data = response.data;

        data.sort((a, b) => {
          if (a.StaffType === b.StaffType) {
            return a.Name.toUpperCase() - b.Name.toUpperCase()
          }
          else {
            return a.StaffType.toUpperCase() < b.StaffType.toUpperCase() ? -1 : 1
          }
        })
        // console.log(data)
        return (data)

      })
      .then((data) => {
        if (this._isMounted) {
          this.setState({ staffs: data });
        }

      })
      .catch(err => console.error(err))

  }

  /**
   * Formats a date field from a staff object for display in the table (MMM-DD-YYYY).
   * @param {Object} d - Object containing the date property named by `p` (e.g. `{ DoB: ... }`).
   * @param {string} p - JSON-stringified key name, e.g. `'"DoB"'`, passed to `JSON.parse` to read `d[key]`.
   * @return {string} Formatted date string, or empty string if the field is missing.
   */
  formatDate = (d, p) => {
    var moment = require('moment');
    var new_date = '';
    JSON.stringify(d);
    if (d[JSON.parse(p)]) {
      new_date = moment(new Date(d[JSON.parse(p)])).format("MMM-DD-YYYY");
      // new_date = moment(d,"MMM-DD-YYYY" );
    }
    // console.log(new_date);
    return new_date;
  }

  /**
   * Renders one table row for a staff record with formatted date columns.
   * @param {Object} staffRow - Staff fields from the API (StaffId, Name, dates, budgets, etc.).
   * @return {JSX.Element} A `<tr>` element for the staff member.
   */
  renderStaff = ({ StaffId, employeeId, StaffType, Name, NRIC, DoB, Marital, Profile, CurrentBudget, DateJoined, LastRevisionDate, psedBudget, wef }) => {

    var DoB_ = this.formatDate({ DoB }, '"DoB"');
    var DateJoined_ = this.formatDate({ DateJoined }, '"DateJoined"');
    var LastRevisionDate_ = this.formatDate({ LastRevisionDate }, '"LastRevisionDate"');
    var wef_ = this.formatDate({ wef }, '"wef"');

    return <tr key={employeeId}>
      <td>{StaffId}</td>
      <td>{StaffType}</td>
      <td>{Name}</td>
      <td>{NRIC}</td>
      <td type="date">{DoB_}</td>
      <td>{Marital}</td>
      <td>{Profile}</td>
      <td type="date">{DateJoined_}</td>
      <td>{CurrentBudget}</td>
      <td type="date">{LastRevisionDate_}</td>
      <td>{psedBudget}</td>
      <td type="date">{wef_}</td>
      {/* <td>
        <button className="btn btn-default btn-sm" onClick={this.deleteStaff.bind(this, {StaffId})}><i className="material-icons">clear</i></button>
      </td> */}
    </tr>


  }

  /**
   * (Legacy) Warns and removes a staff member locally and via DELETE API — UI action is currently commented out.
   * @param {Object} staffId - Object shaped like `{ StaffId }` identifying the row to remove.
   * @return {void}
   */
  deleteStaff = (staffId) => {
    console.log(staffId["StaffId"]);

    NotificationManager.warning("Deleting this staff will result in deleting all the reserve and budget records.");


    // Delete from the list
    this.setState(state => {
      // this.state.staffs = this.deleteStaffFromList(staffId["StaffId"]);

      this.setState({ staffs: this.deleteStaffFromList(staffId["StaffId"]) })
      return this.state;
    });


    // Delte from the SQL Database by calling HTTP delete request to api
    this.deleteStaffFromSQL(staffId["StaffId"])
      .then((data) => {
        console.log('finish deleting');
        console.log(data);
      })
      .catch(err => err);

  }

  /**
   * Sends a DELETE request to remove a staff member on the server.
   * @param {string|number} id - Staff id used in the API path `api/staff/:id`.
   * @return {Promise<Response|*>} Fetch response, or caught error object on failure.
   */
  deleteStaffFromSQL(id) {
    console.log('sql param is ' + id);

    return fetch(backend + 'api/staff/' + id, {
      method: 'DELETE',
      credentials: "include"
    })
      .then(res => res)
      .catch(err => err);
  }

  /**
   * Returns a new staff array excluding the given `StaffId` (immutable filter).
   * @param {string|number} id - `StaffId` to exclude.
   * @return {Array<object>} Filtered copy of `this.state.staffs`.
   */
  deleteStaffFromList(id) {
    return this.state.staffs.filter(staffs => staffs.StaffId !== id);
  }

  /**
   * Renders logout redirect, the staff table when data is loaded, or a loading heading while the list is empty.
   * @return {JSX.Element}
   */
  render() {

    const { redirectLogout } = this.state;

    if (redirectLogout) {
      return (
        <BrowserRouter>
          <Switch>
            <Route exact path="/logout" component={Logout} />
            <Redirect to="/logout" />
          </Switch>
        </BrowserRouter>
      )
    }

    const { staffs } = this.state;
    staffs.sort((a, b) => {
      return a.StaffType - b.StaffType || a.Name - b.Name;
    });

    if (staffs.length !== 0) {

      return (<div>
        <h2>Manage Staff</h2>

        <div className="react-bootstrap-table">
          <ScrollContainer className="scroll-container">

            <table className="table table-striped table-hover">
              <thead>
                <tr>
                  <th>Desig ID</th>
                  <th>Type</th>
                  <th>Name</th>
                  <th>NRIC</th>
                  <th>DoB</th>
                  <th>Marital</th>
                  <th>Profile</th>
                  <th>Date Joined</th>
                  <th>Current Budget</th>
                  <th>Last Revision Date</th>
                  <th>Proposed Budget</th>
                  <th>w.e.f</th>
                  {/*<th>Action</th>*/}
                </tr>
              </thead>
              <tbody>
                {staffs.map(this.renderStaff)}
              </tbody>
            </table>

          </ScrollContainer>
        </div>

      </div>);

    }
    else {
      return (<h2> Loading... </h2>)
    }

  }
}

export default Manage_Staff;
